<!---底部-->
<template>
  <div class="overall-bottom-wrapper" v-show="!hideBottom">
    <slide-tips/>
    <div class="overall-bottom-bg" :class="{bottomAnimate:isShow}">
      <div class="overall-bottom">
        <BottomGuide ref="guideRef" @handleOffGuide="isOffGuide"  :class="{'slide-in':isShowGuide,'slide-out':!isShowGuide}" :audioContent="audioContent" :muted="muted"/>
        <scene-list :class="{'slide-out':isShow,'slide-in':!isShow}" />
        <BottomBtns @showGuide="getAnimate" :value="isShow" :hasSmartGuide="hasSmartGuide"/>
      </div>
      <div class="overall-bottom-waves">
        <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
        <defs>
        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"></path>
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.05"></use>
          <use xlink:href="#gentle-wave" x="48" y="7" fill="rgba(255,255,255,0.05)"></use>
        </g>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SceneList from '@/components/SceneList';
import BottomBtns from '@/components/BottomNew/BottomBtns';
import BottomGuide from '@/components/BottomNew/BottomGuide';
import * as layerNames from '@/services/layerName';
import layerManager from '@/services/layer.manager';
import SlideTips from '@/components/SlideTips.vue';


export default {
  name: 'Bottom',
  data () {
    return {
      sceneBtn: { selected: true },
      sceneList4d: [],
      isShow:false,
      isShowGuide:false,
      parentValue: false
    };
  },
  props: {
    audioContent: {
      type: Object,
      default:null
    },
    hasSmartGuide: {
      type: Boolean,
      default: false
    },
    muted: {
      type: Boolean,
      default: false
    },
  },
  components: {
    SceneList,
    BottomBtns,
    BottomGuide,
    SlideTips
  },
  computed: {
    ...mapGetters({
      isSHowSmartGuide: 'isSHowSmartGuide',
      hideBottom:'hideBottom'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    },
    channelId () {
      return this.vrSalesInfo.channelId;
    },
  },

  mounted () {
    const self = this;
    this.$nextTick(() => {
      let el = self.$refs['scene-list'];
      // self.scrollSync = new ScrollSync('vue_bottom', el);
    });
  },
  methods: {
    getAnimate(){
      this.isShow = !this.isShow
      setTimeout(()=>{
        this.isShowGuide = !this.isShowGuide
      },400)

    },
    isOffGuide () {
      layerManager.open(layerNames.OFFCALLMODAL, {
        title: '结束智能导览',
        content: '您将结束本次智能导览服务，是否确定结束？',
        showCancel: true,
        cancelText: '再等等',
        okText: '确定结束',
        onOk: () => {
          this.offGuide();
        },
      });
    },
    offGuide () {
      this.isShowGuide = !this.isShowGuide
      this.$bus.$emit('cancelSmartGuide')
      this.$refs['guideRef'].isSHowActivityAndPacket = false
      setTimeout(()=>{
        this.isShow = !this.isShow
      }, 800)
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/modules/BottomNew.scss";
</style>
